import { styled } from '@mui/material/styles';
import {
  Typography,
  Button,
  Stack,
  Card,
  CardHeader,
  CardContent,
} from '@mui/material';

export const MainContainer = styled('span')({
  display: 'block',
});

export const HeaderContainer = styled(Stack)(({ theme }) => ({
  justifyContent: 'space-between',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(1),
    alignItems: 'flex-start',
  },
}));

export const MainHeading = styled(Typography)(({ theme }) => ({
  fontSize: '2.5em',
  fontWeight: '400',
  lineHeight: 1.2,
  color: theme.palette.text.primary,
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.8rem',
    lineHeight: 1.3,
  },
}));

export const LinkedInButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
  },
}));

export const EndorsementsStack = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
}));

export const EndorsementCardContainer = styled(Stack)({
  width: '100%',
});

export const EndorsementCard = styled(Card)(({ theme }) => ({
  width: '100%',
  height: 'auto',
  margin: theme.spacing(0.625),
  padding: theme.spacing(0.625),
  boxShadow: theme.shadows[1],
}));

export const EndorsementCardHeader = styled(CardHeader)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  borderRadius: '4px 4px 0px 0px',
  margin: `-${theme.spacing(0.625)}`,
  boxShadow: theme.shadows[1],
  '& .MuiCardHeader-title': {
    color: theme.palette.primary.contrastText,
    fontSize: '1.5rem',
    fontWeight: '500',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.2rem',
      lineHeight: 1.3,
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      maxWidth: '100%',
    },
  },
  '& .MuiCardHeader-subheader': {
    color: theme.palette.primary.contrastText,
    opacity: 0.9,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
      lineHeight: 1.2,
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      maxWidth: '100%',
    },
  },
  '& .MuiCardHeader-action': {
    color: theme.palette.primary.contrastText,
    fontSize: '1rem',
    fontWeight: '400',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.75rem',
      lineHeight: 1.3,
      textAlign: 'left',
      marginTop: theme.spacing(0.5),
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      maxWidth: '100%',
      flexShrink: 1,
    },
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
    '& .MuiCardHeader-content': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(0.5),
      width: '100%',
    },
    '& .MuiCardHeader-action': {
      width: '100%',
      flex: '1 1 auto',
    },
  },
}));

export const EndorsementCardContent = styled(CardContent)(({ theme }) => ({
  alignContent: 'center',
  padding: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
  },
}));

export const HighlightCard = styled(Card)(({ theme }) => ({
  width: 'fit-content',
  height: 'auto',
  margin: theme.spacing(0.625),
  padding: theme.spacing(0.625),
  backgroundColor: 'rgba(212, 225, 244, 0.8)',
  '& .MuiPaper-root': {
    backgroundColor: 'rgba(212, 225, 244, 0.8)',
  },
}));

export const HighlightCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(1.5),
}));

export const ReviewText = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  fontWeight: '400',
  lineHeight: 1.5,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem',
    lineHeight: 1.4,
  },
}));

export const ReviewerInfo = styled(Typography)(({ theme }) => ({
  textAlign: 'right',
  fontSize: '1rem',
  fontWeight: '400',
  color: theme.palette.text.secondary,
  fontStyle: 'italic',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9rem',
    textAlign: 'left',
  },
}));
